//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { ref, computed, onMounted } from '@vue/composition-api'
import { useRouter } from '@core/utils'
import { getPublicFeedback, savePublicFeedback } from '@api'
import { i18n, getI18nLanguage } from '@/plugins/i18n'

/**
 * "¿Qué te pareció esta funcionalidad?" — destino de las tres caritas de un
 * mail (fastapi base_template.feedback_block). El token firmado identifica
 * usuario + funcionalidad + referencia; `?r=1..3` es la carita tocada en el
 * mail y se guarda apenas carga la página (un toque = una respuesta). Acá el
 * jugador puede cambiarla o dejar un comentario.
 */
export default {
  name: 'FeatureFeedback',
  setup() {
    const t = (key, params) => i18n.t(key, params)
    const { route } = useRouter()

    const state = ref('loading') // loading | invalid | form
    const page = ref(null)
    const rating = ref(null)
    const comment = ref('')
    const submitting = ref(false)
    const savedMsg = ref('')
    const errorMsg = ref('')
    const commentRef = ref(null)

    const faces = [
      { rating: 1, emoji: '😕' },
      { rating: 2, emoji: '😐' },
      { rating: 3, emoji: '😍' },
    ]

    const token = computed(() => route.value.params.token)
    const lang = computed(() => (getI18nLanguage() === 'es' ? 'es' : 'en'))
    const title = computed(() => (page.value ? page.value[`title_${lang.value}`] : ''))
    const reference = computed(() => (page.value && page.value.reference ? page.value.reference[lang.value] : ''))
    const commentHint = computed(() => (page.value ? page.value[`comment_hint_${lang.value}`] : ''))

    const load = async () => {
      let res = null
      try {
        res = await getPublicFeedback(token.value)
      } catch (e) {
        res = null
      }
      if (!res || res.ok !== 1 || !res.data) {
        state.value = 'invalid'

        return
      }
      page.value = res.data
      rating.value = res.data.rating || null
      comment.value = res.data.comment || ''

      // La carita del mail: se guarda al abrir, sin pedir nada más.
      const fromMail = Number(route.value.query.r)
      if ([1, 2, 3].includes(fromMail) && fromMail !== rating.value) {
        rating.value = fromMail
        try {
          await savePublicFeedback(token.value, fromMail)
          savedMsg.value = t('feature_feedback.saved_short')
        } catch (e) {
          // Se reintenta con "Enviar"; la página sigue siendo útil.
        }
      }
      state.value = 'form'
    }

    const pick = r => {
      rating.value = r
      savedMsg.value = ''
      if (r === 1 && commentRef.value) commentRef.value.focus()
    }

    const submit = async () => {
      if (!rating.value) return
      submitting.value = true
      errorMsg.value = ''
      savedMsg.value = ''
      try {
        const res = await savePublicFeedback(token.value, rating.value, comment.value || '')
        if (res && res.ok === 1) {
          savedMsg.value = t('feature_feedback.saved')
        } else {
          errorMsg.value = (res && res.message) || t('feature_feedback.error')
        }
      } catch (e) {
        errorMsg.value = t('feature_feedback.error')
      } finally {
        submitting.value = false
      }
    }

    onMounted(load)

    return {
      t,
      state,
      faces,
      rating,
      comment,
      commentRef,
      title,
      reference,
      commentHint,
      submitting,
      savedMsg,
      errorMsg,
      pick,
      submit,
    }
  },
}
